// extracted by mini-css-extract-plugin
export default {"wrapper":"Fca-z","boldPrefix":"Gca-z","link":"Hca-z","message":"Ica-z","image":"Jca-z"};